import React from 'react';
import {
  Container, Typography, Grid, Paper, Box,
  Card, CardContent, CardMedia, useTheme, useMediaQuery
} from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import StorefrontIcon from '@mui/icons-material/Storefront';
import HandshakeIcon from '@mui/icons-material/Handshake';
import GradientBackground from '../components/GradientBackground';

const AboutUs = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const features = [
    {
      icon: <LocalShippingIcon sx={{ fontSize: 60, color: 'primary.main' }} />,
      title: 'Distribuidores Confiables',
      description: 'Red verificada de distribuidores con experiencia en diferentes zonas del país.'
    },
    {
      icon: <StorefrontIcon sx={{ fontSize: 60, color: 'primary.main' }} />,
      title: 'Comercios Locales',
      description: 'Apoyo al crecimiento de pequeños y medianos comercios conectando con los mejores proveedores.'
    },
    {
      icon: <HandshakeIcon sx={{ fontSize: 60, color: 'primary.main' }} />,
      title: 'Conexiones Directas',
      description: 'Facilitamos la comunicación directa entre comercios y distribuidores'
    }
  ];

  return (
    <GradientBackground>
    <Container maxWidth="lg" sx={{ py: 6 }}>
      {/* Hero Section */}
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography sx={{color:'white', fontSize: (isMobile ? '1.5rem' : '2rem')}} variant="h3" component="h1" gutterBottom>
          Somos Liderdist, la red de proveedores y comercios. Un marketplace B2B para distribuidores y comercios locales.
        </Typography>
        <Typography variant="h6" sx={{ mb: 4,color:'white' }}>
          Te ayudamos a conectar con los mejores proveedores y clientes
        </Typography>
      </Box>

      {/* Features Section */}
      <Grid container spacing={4} sx={{ mb: 6 }}>
        {features.map((feature, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Paper 
              elevation={3}
              sx={{
                p: 3,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center'
              }}
            >
              {feature.icon}
              <Typography variant="h6" sx={{ my: 2 }}>
                {feature.title}
              </Typography>
              <Typography color="text.secondary">
                {feature.description}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* Mission Section */}
      <Paper elevation={3} sx={{ p: 4, mb: 6 }}>
        <Typography variant="h4" gutterBottom>
          ¿Por qué nosotros?
        </Typography>
        <Typography variant="body1" paragraph>
          En Liderdist no se cobran comisiones. Se pueden publicar hasta cinco productos sin costo. Luego, el costo es únicamente una subscripción mensual para publicar productos.
          Existimos exclusivamente para ayudar a los comercios locales a encontrar los mejores proveedores.

        </Typography>
        <Typography variant="body1">
        Las conexiones se realizan directamente entre comercios y distribuidores.
        A través del sistema de verificación, otorgamos la confianza necesaria para que los comercios puedan contactar con los distribuidores.
        </Typography>
      </Paper>

      {/* Stats Section */}
      {/* <Grid container spacing={3} sx={{ mb: 6 }}>
        {[
          { number: '50+', label: 'Comercios Activos' },
          { number: '20+', label: 'Distribuidores Verificados' },
          { number: '100+', label: 'Conexiones Exitosas' }
        ].map((stat, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Card>
              <CardContent sx={{ textAlign: 'center' }}>
                <Typography variant="h3" color="primary" gutterBottom>
                  {stat.number}
                </Typography>
                <Typography variant="h6" color="text.secondary">
                  {stat.label}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid> */}
    </Container>
    </GradientBackground>
  );
};

export default AboutUs;